import { render, staticRenderFns } from "./NmsDashboard.vue?vue&type=template&id=1b8189b2&scoped=true&"
import script from "./NmsDashboard.vue?vue&type=script&lang=js&"
export * from "./NmsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NmsDashboard.vue?vue&type=style&index=0&id=1b8189b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8189b2",
  null
  
)

export default component.exports